import { PageLayout } from '../layout/PageLayout'
import { Title } from '@app/components/core/typography/Title'
import { useTranslations } from '@i18n/useLanguage'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export const Events = () => {
  const t = useTranslations().app.eventsPage
  return (
    <PageLayout>
      <PageSeo pageTitle={t.title} description={t.description} />
      <Title.H1>{t.title}</Title.H1>
    </PageLayout>
  )
}
